import { Box } from "@mui/material";
import AppCheckBox from "components/AppCheckBox";
import Scrollbar from "components/ScrollBar";
import { useEmployeeDirectoryState } from "contexts/employeeDirectoryContext";
import { useMemo } from "react";
import ColumnShape from "./columnShape";
import { DefaultDataTable } from "components/CustomDataTable";

export default function ListTable({ data, singleSelect }) {
  const {
    checkedEmployees,
    setCheckEmployee,
    setUncheckEmployee,
    setCheckSingleEmployee,
    setUncheckSingleEmployee,
  } = useEmployeeDirectoryState();
  const tableData = useMemo(() => data.rows, [data.rows]);
  const columns = useMemo(
    () => [
      {
        Header: "",
        accessor: "checked",
        Cell: ({ row }) => {
          const { id } = row.original;
          return (
            <AppCheckBox
              checked={
                checkedEmployees.find((employee) => employee.id === id) !==
                undefined
              }
              onChange={(e) => {
                console.log("checked", e.target.checked, row.original);

                if (singleSelect) {
                  if (e.target.checked) setCheckSingleEmployee(row.original);
                  else setUncheckSingleEmployee(row.original);
                } else {
                  if (e.target.checked) setCheckEmployee(row.original);
                  else setUncheckEmployee(row.original);
                }
              }}
            />
          );
        },
      },
      ...ColumnShape,
    ],
    [checkedEmployees]
  );

  return (
    <Box>
      <Scrollbar autoHide={false}>
        <DefaultDataTable columns={columns} data={tableData} />
      </Scrollbar>
    </Box>
  );
}
